import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Document from "../../../custom/Document";
import KYCDoc from "./kycdoc";
import {API} from "../../../../config";
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const investorUploads = API.service('investors-uploaded-files');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class InvestorWithdrawals extends Component {
    state={
        poid:[],
        poad:[]
    };

    getKYC = () => {
        const app = this;
        investorUploads.find({query:{_account:this.props.investor._account, _fieldname:'_upload_id',$sort:{_creationdate:-1}}}).then(s=>{
            app.setState({
                poid:s.data
            })
        })
        investorUploads.find({query:{_account:this.props.investor._account, _fieldname:'_upload_address',$sort:{_creationdate:-1}}}).then(a=>{
            app.setState({
                poad:a.data
            })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.investor._id !== this.props.investor._id) {
            const app = this;
            this.setState({
                poid:[],
                poad:[],
            },app.getKYC());
        }
    }

    componentDidMount() {
        this.getKYC()
    }

    onComplete = () => {
        const app = this;
        this.setState({
            poid:[],
            poad:[],
        },app.getKYC());

    }

    render() {
        return (
            <React.Fragment>
                <div className={'flex'}>
                    <Paper className={'flex-1 mr-1'} style={{position:'relative', margin:5}}>

                        <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={"flex-1"}>
                                    Proof of Identity
                                </Typography>
                                <Document hideImage={true} investor={this.props.investor._account} type='_upload_id' label='Proof of Identity'
                                          placeholder='/assets/images/profile/default_photo.jpg' hideReviewStatus={true} onComplete={()=>this.onComplete()}/>
                            </Toolbar>
                        </AppBar>
                        <div className="p-12">

                        {this.state.poid.map((v,i)=>{
                            return (<React.Fragment>
                                <KYCDoc data={v} key={i} />
                            </React.Fragment>)
                        })}
                        </div>
                    </Paper>
                    <Paper className={'flex-1 mr-1'} style={{position:'relative', margin:5}}>

                        <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={"flex-1"}>
                                    Proof of Address
                                </Typography>
                                <Document hideImage={true} investor={this.props.investor._account} type='_upload_address' label='Proof of Address'
                                          placeholder='/assets/images/profile/default_photo.jpg' hideReviewStatus={true} onComplete={()=>this.onComplete()}/>
                            </Toolbar>
                        </AppBar>
                        <div className="p-12">
                            {this.state.poad.map((v,i)=>{
                                return(<React.Fragment>
                                    <KYCDoc data={v} key={i} />
                                </React.Fragment>)
                            })}
                        </div>
                    </Paper>
                </div>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(InvestorWithdrawals)));
